import React from "react";
import "./ClientCarousel.css";
const clientLogos = [
  "Parle.svg",
  "Yamaha_logo.svg",
  "dtdc.png",
  "meta.png",
  "nichino.png",
  "Swiss_castle_bakery.png",
  "Lfhs.png"
];

const ClientCarousel = () => {
  return (
    <div className="clients-section">
      <div className="clients-track">
        {[...clientLogos, ...clientLogos].map((logo, index) => (
          <div className="client-logo" key={index}>
            <img src={require(`../assets/logos/${logo}`)} alt={`Client ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientCarousel;
